import { cancelOffer, confirmCancellation, submitNoteAndComment } from '../../api/offers';

const actions = {

  async cancelOffer({ commit }, payload) {
    try {
      const response = await cancelOffer(payload.userId, payload.purchaseId);
      commit('SET_MESSAGE', response.data.message);
      return response.data;
    } catch (error) {
      console.error('An error occurred while cancelling the offer:', error);
      commit('SET_MESSAGE', 'Failed to Cancel Offer');
      return null;
    }
  },
  async confirmCancellation({ commit }, payload) {
    try {
      const response = await confirmCancellation(payload.userId, payload.purchaseId);
      commit('SET_MESSAGE', response.data.message);
      return response.data;
    } catch (error) {
      console.error('An error occurred while confirming the cancellation of the offer:', error);
      commit('SET_MESSAGE', 'Failed to Confirm Cancellation of Offer');
      return null;
    }
  },
  async submitNoteAndComment({ commit }, payload) {
    try {
      const response = await submitNoteAndComment(
        payload.userId, 
        payload.purchaseId, 
        payload.note, 
        payload.comment
      );
      commit('SET_MESSAGE', response.data.message);
      return response.data;
    } catch (error) {
      console.error('An error occurred while submitting the note and comment:', error);
      commit('SET_MESSAGE', 'Failed to Submit Note and Comment');
      return null;
    }
  }

};

export default {
    actions
  };
